import React from 'react'
import PropTypes from 'prop-types'

const ErrorIcon2 = (props) => {
  const { color = '#DC2626', classes = '' } = props
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M9.5 0.460938C4.256 0.460938 0 4.71694 0 9.96094C0 15.2049 4.256 19.4609 9.5 19.4609C14.744 19.4609 19 15.2049 19 9.96094C19 4.71694 14.744 0.460938 9.5 0.460938ZM10.45 14.7109H8.55V12.8109H10.45V14.7109ZM10.45 10.9109H8.55V5.21094H10.45V10.9109Z"
        fill={color}
      />
    </svg>
  )
}

ErrorIcon2.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ErrorIcon2)
